import React from 'react'
import Shimmer from './Shimmer'
import "./PhotoSkeleton.scss"
import { FaImage } from "react-icons/fa"
const PhotoSkeleton = () => {
  return (
    <div className="pushi">
      <div className='PhotoSkeleton_Container'>
        <div className="PhotoSkeleton_wrapper">
          <div className="PhotoSkeleton_Img"> <FaImage /></div>
        </div>

        <Shimmer />
      </div>
    </div>

  )
}

export default PhotoSkeleton
